import { queryOptions } from '@tanstack/react-query';
import {
  type GetChargingPowerChartsResponse,
  type GetChargingPowerChartsSearchParameters,
} from '../types/battery-monitoring-api';
import { batteryMonitoringApi } from '../battery-monitoring-api';

export const getChargingPowerChartsQueryOptions = (
  searchParameters: GetChargingPowerChartsSearchParameters,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type -- queryOptions as return type should be inferred
) =>
  queryOptions<GetChargingPowerChartsResponse>({
    queryKey: ['getChargingPowerCharts', searchParameters],
    queryFn: async () => await batteryMonitoringApi.getChargingPowerCharts(searchParameters),
  });
